import Page from "constants/page";
import Qs from "qs";
import { endOfDay, endOfWeek, startOfDay, startOfWeek, subDays, subWeeks } from "date-fns";
import { InteractionType } from "@edgetier/watchtower-types";

/**
 * Create default URL parameters that should be passed to some routes.
 */
export const getDefaultRouteUrls = (): {
    [index: string]: { parameters: Object; url: string };
} => {
    const liveParameters = { interactionType: InteractionType.Chat };
    const agentsParameters = {
        interactionType: InteractionType.Chat,
        endDateTime: endOfDay(subDays(new Date(), 1)),
        startDateTime: startOfDay(subDays(new Date(), 14)),
    };
    const exploreParameters = {
        endDateTime: endOfDay(new Date()),
        startDateTime: startOfDay(subDays(new Date(), 13)),
    };

    // Email is not yet ready to review agents.
    const agentParameters = { interactionType: InteractionType.Chat };

    // Default to the last full week.
    const exploreTagParameters = {
        endDateTime: endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }),
        startDateTime: subWeeks(startOfWeek(new Date(), { weekStartsOn: 1 }), 1),
    };

    return {
        [Page.Explore]: {
            parameters: exploreParameters,
            url: `${Page.Explore}${Qs.stringify(exploreParameters, { addQueryPrefix: true })}`,
        },
        [Page.Agent]: {
            parameters: agentParameters,
            url: `${Page.Agent}${Qs.stringify(agentParameters, { addQueryPrefix: true })}`,
        },
        [Page.Live]: {
            parameters: liveParameters,
            url: `${Page.Live}${Qs.stringify(liveParameters, { addQueryPrefix: true })}`,
        },
        [Page.Agents]: {
            parameters: agentsParameters,
            url: `${Page.Agents}${Qs.stringify(agentsParameters, { addQueryPrefix: true })}`,
        },
        [Page.ExploreTags]: {
            parameters: exploreTagParameters,
            url: `${Page.ExploreTags}${Qs.stringify(exploreTagParameters, { addQueryPrefix: true })}`,
        },
    };
};
